

import axios from "axios";
const jsonConfig = require("../../Config.json");

const getCandidateFieldOptions = async () => {
  try {
    const resp = await axios.get(
      jsonConfig.apiUrl + 'getCandidateFieldOptions',
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    let decompressedObject;
    if (resp?.data && resp?.data?.compressedBase64String) {
        // Lazy load fflate only when needed
        const { unzlibSync, strFromU8 } = await import("fflate");
        
        const strData = atob(resp.data.compressedBase64String);
        
      const charData = strData.split("").map((x) => {
        return x.charCodeAt(0);
      });
      const binData = new Uint8Array(charData);
      let apiDataUnCompressed = unzlibSync(binData);
      let apiDataUnCompressedString = strFromU8(apiDataUnCompressed);
      decompressedObject = JSON.parse(apiDataUnCompressedString);
    }

    return decompressedObject
  } catch (err) {
    console.log(err);
    return Promise.reject(err);
  }
};

export default getCandidateFieldOptions;
